import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { FormGroup, Label } from 'reactstrap';
import { getClientEngagementList as onGetClientEngagementList } from 'store/actions';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import axios from "axios";
import { API_URL } from 'helpers/app_url';
async function fetchSellerDeals(clientId) {
  try {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    const url = `${API_URL}ClientEngagement/allbyselectedtypesstatus`;

    const body = {
      clientId: parseInt(clientId),
      agentId: parseInt(localStorage.getItem("userId")),
      statusIds: [0],
      typeId: 2,
    };

    const response = await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching buyer deals:", error);
    return [];
  }
}
const EngagementListSellerClient = ({ name, clientId, agentId, typeId, statusId, selectedData }) => {
   const { values, errors, touched, setFieldValue, handleBlur } = useFormikContext();
  const [clientengagements, setEngagements] = useState([]);

  // useEffect(() => {
  //   if (clientId && agentId) {
  //     fetchSellerDeals(clientId).then((data) => setEngagements(data));
  //   }
  //    if (data.length === 1) {
  //         setFieldValue(name, data[0].id);
  //       }
  // }, [clientId, agentId]);


    useEffect(() => {
      if (clientId && agentId) {
        fetchSellerDeals(clientId).then((data) => {
          setEngagements(data);
  
          
          // if (data.length === 1) {
          //   setFieldValue(name, data[0].id);
          // }
        });
      }
    }, [clientId, agentId, name, setFieldValue]);
   

    const getType = (type) => type === 1 ? 'Rent' : type === 2 ? 'Purchase' : 'Unknown Type';
    const getSType = (type) => type === 1 ? 'Sell' : type === 2 ? 'Lease' : 'Unknown Type';

    const formatYYMM = (dateStr) => {
        if (!dateStr) return "0000";
        const date = new Date(dateStr);
        const yy = String(date.getFullYear()).slice(2);
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        return `${yy}${mm}`;
    };

    
    const fieldError = name.split('.').reduce((acc, key) => acc?.[key], errors);
    const fieldTouched = name.split('.').reduce((acc, key) => acc?.[key], touched);
    const fieldValue = name.split('.').reduce((acc, key) => acc?.[key], values);

    return (
        <FormGroup className="mb-3">
            <Label htmlFor={name}>Select Deal *</Label>
            <select
                name={name}
                className={`form-control ${fieldError && fieldTouched ? "is-invalid" : ""}`}
                onChange={(e) => setFieldValue(name, e.target.value)}
                onBlur={handleBlur}
                value={fieldValue || ""}
                disabled={selectedData}
            >
            <option value="">Select</option>
                {clientengagements?.map(option => {
                    if (option.clientEngagementStatus === 3 && option.id !== Number(fieldValue)) {
                        return null;
                    }

                    const label = option.isBuyer
                        ? `${getType(option.buyerType)} - (${option.id} - ${formatYYMM(option.lastAgreementDate)})`
                        : `${getSType(option.sellerType)} - (${option.id} - ${formatYYMM(option.lastAgreementDate)})`;

                    return (
                        <option key={option.id} value={option.id}>
                            {label}
                        </option>
                    );
                })}
            </select>
            {fieldError && fieldTouched && (
                <div className="invalid-feedback">{fieldError}</div>
            )}
        </FormGroup>
    );
};

EngagementListSellerClient.propTypes = {
    name: PropTypes.string.isRequired,  
    clientId: PropTypes.string.isRequired,
    agentId: PropTypes.string.isRequired,
    typeId: PropTypes.number,
    statusId: PropTypes.number,
    selectedData: PropTypes.number
};

export default EngagementListSellerClient;
